import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {MenuItem} from "primeng/api";
import {
    OverviewStatisticsBaseComponent
} from "../../../../../../core/shared/overview/overview-statistics-base.component";
import {WidgetData} from "../../../../../../core/shared/widget/widget-data";
import {OverviewDto} from "../../../../../../core/shared/overview/dto/overview.dto";
import {MvsCoreService} from "../../../../../../core/shared/service/mvs-core.service";
import {WidgetFactory} from "../../../../../../core/shared/widget/service/widget.factory";
import {WidgetDataParam} from "../../../../../../core/shared/widget/widget-data-param";
import {ObjectRequestListGroupBy} from "../../../../../../core/shared/dto/object/request/object-request-list-group-by";
import {
    ObjectRequestListAttribute
} from "../../../../../../core/shared/dto/object/request/object-request-list-attribute";
import {
    DtoListAttributeRequestAggregateEnum
} from "../../../../../../core/shared/dto/enum/dto-list-attribute-request-aggregate.enum";
import {Sorting} from "../../../../../../core/shared/misc/sorting";


@Component({
    selector: 'im-statistics',
    templateUrl: 'im-statistics.component.html',
    standalone: false
})
export class ImStatisticsComponent extends OverviewStatisticsBaseComponent implements OnInit, OnChanges, OnDestroy {

    pending: number = 0;
    processed: number = 0;
    inProcess: number = 0;
    unfinished: number = 0;


    importHistoryWidget: WidgetData;
    importsBySystemWidget: WidgetData;
    importRecordsByImportWidget: WidgetData;
    recentlyAddedImportsWidget: WidgetData;

    items: MenuItem[] | undefined;

    home: MenuItem | undefined;
    overviewDto: OverviewDto[];

    constructor(
        private router: Router,
        protected route: ActivatedRoute,
        protected coreService: MvsCoreService) {
        super(route, coreService)
    }

    ngOnInit(): void {


        this.items = [
            {label: 'IM Module'},
        ];

        this.home = {icon: 'pi pi-home', routerLink: '/'};
        super.ngOnInit();
        this.initComponent();
        this.overviewDto = [
            { label: 'Pending Registrations', value: 0 },
            { label: 'Processed Registrations', value: 0 },
            { label: 'In-Process Registrations', value: 0 },
            { label: 'Unfinished Registrations', value: 0 }
        ];
    }

    /**
     * Initialize Component.
     */
    initComponent() {
        this.refreshComponent();

    }

    /**
     * Refresh Component.
     */
    refreshComponent() {
        this.refreshAppointmentHistoryWidget();
        this.refreshAppointmentByTypeWidget();
        this.refreshAppointmentTypeByGroupWidget();
        this.refreshAddedAppointment();
        this.initialized = true;
    }

    navigateToConfig() {
        this.router.navigate(['/ui/config']);
    }



    refreshAppointmentHistoryWidget() {
        this.importHistoryWidget = WidgetFactory.createWidget(
            'im.import.overview.history.widget',
            'Imports History',
            'history.chart',
            'list',
            'entity.groupBy',
            'im.ImImport',
            WidgetDataParam.create("fieldCategory", "severity"),
            WidgetDataParam.create("fieldCategoryCount", "severity_count"),
            WidgetDataParam.create("historyPeriodMode", "month"),
            WidgetDataParam.create("fieldDate", "createdDate"),
            WidgetDataParam.create("selectionMode", "single"),
            WidgetDataParam.create("size", "S")
        );
        this.importHistoryWidget.dataProviderListRequest = ObjectRequestListGroupBy.create(
            true,
            this.filterCriteria,
            [],
            ["severity", "createdDate"],
            [new ObjectRequestListAttribute("severity", "severity", DtoListAttributeRequestAggregateEnum.count)]
        );
    }

    refreshAppointmentByTypeWidget() {
        this.importsBySystemWidget = WidgetFactory.createWidgetGroupBy(
            'im.import.overview.by.type.widget',
            'Imports By System',
            'category',
            'entity.groupBy',
            'im.ImImport',
            'externalSystem',
            'externalSystem_count',
            this.filterCriteria,
            'externalSystem',
            'Anzahl');
    }

    refreshAppointmentTypeByGroupWidget() {
        this.importRecordsByImportWidget = WidgetFactory.createWidgetGroupBy(
            'im.import.overview.records.by.import.widget',
            'Import Records By Import',
            'category',
            'entity.groupBy',
            'im.ImImportRecord',
            'status',
            'status_count',
            this.filterCriteria,
            'status',
            'Anzahl');
    }

    refreshAddedAppointment() {

        this.recentlyAddedImportsWidget = WidgetFactory.createWidgetTableEntityBasicQl('im.import.overview.recently.added.imports', 'Recent Imports', 'im.ImImport', this.filterCriteriaForQuery, [new Sorting('e.createdDate', false)])
    }

    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {

        if (!this.initialized) {
            return;
        }

        if (changes["id"]) {
            this.refreshComponent();
        }
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {

    }
}
